import React from 'react';
import CKWysiwyg from '../CKWysiwyg/CKWysiwyg';

const CKWysiwygField = ({
    input,
    withShortcodes,
    withColors,
    withImages,
    withTables,
}) => {
    return (
        <CKWysiwyg
            defaultValue={input?.value}
            onChange={input?.onChange}
            withShortcodes={withShortcodes}
            withColors={withColors}
            withImages={withImages}
            withTables={withTables}
        />
    );
};

export default CKWysiwygField;
